import { Injectable } from '@angular/core'
import type { ListPageProperties, SegmentTagV2 } from '../shared/analytics/models/segment-tag.model'
import { SegmentService } from '../shared/analytics/services/segment.service'

/**
 * The standard Page tag for the results (/results) page view.
 *
 * @remarks
 * This is expected to be used with pageV2, as indicated by the use of the
 * SegmentTagV2 interface and `autoPageCall: false`.
 *
 * @see SegmentService#pageV2
 * @see SegmentTagV2
 */
export const RESULTS_TAG: SegmentTagV2 = {
  page_category: 'Results',
  category: 'Results',
  autoPageCall: false
}

@Injectable()
export class ResultsAnalyticsService {
  public constructor(private readonly segment: SegmentService) {}

  public sendPageCall(pageProperties: ListPageProperties = { _tag: 'list' }): void {
    this.segment.pageV2(RESULTS_TAG, pageProperties)
  }
}
